<script>
import Cloner from "@/libraries/Cloner";
import PmNoteService from "@/services/PmNoteService";

export default {
    props: {
        context: {},
        projectId: {}
    },
    data() {
        return {
            editing: false,
            saving: false,
            loading: true,
            errors: {},
            entity: {
                id: null,
                project_id: null,
                description: null
            }
        };
    },
    async created() {
        if (this.context.empty) {
            this.editing = false;
        } else {
            this.editing = true;
            this.entity = Cloner.pickClone(this.context, [
                "id",
                "project_id",
                "description"
            ]);
        }

        this.entity.project_id = this.projectId;

        this.loading = false;
    },
    methods: {
        async saveForm() {
            try {
                this.saving = true;
                if (this.editing) {
                    await PmNoteService.PUT(this.entity);
                } else {
                    await PmNoteService.POST(this.entity);
                }

                this.$emit("close-reload");
            } catch (e) {
                this.errors = e.response.data.errors;
                console.log("save e ", e);
            }

            this.saving = false;
        },
        async deleteEntity() {
            this.$swal({
                icon: "warning",
                text: this.$t("pm_notes.confirm_delete"),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    try {
                        this.$notify({
                            message: this.$t("pm_notes.deleted"),
                            timeout: 5000,
                            icon: "far fa-check",
                            type: "success"
                        });
                        await PmNoteService.DELETE(this.context.id);
                        this.$emit("close-reload");
                    } catch (e) {}
                }
            });
        }
    }
};
</script>

<template>
    <modal
        size=""
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            <template v-if="editing">{{ $t("pm_notes.edit") }}</template>
            <template v-else>{{ $t("pm_notes.create") }}</template>
        </template>

        <template slot="default">
            <FormulateForm v-model="entity" @submit="saveForm" :errors="errors">
                <div class="row">
                    <div class="col-12">
                        <FormulateInput
                            name="description"
                            type="textarea"
                            :placeholder="$t('pm_notes.note_placeholder')"
                            :label="$t('pm_notes.hdr_note')"
                            rows="8"
                            validation="required"
                        />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col">
                        <base-button
                            type="danger"
                            :outline="true"
                            v-if="editing"
                            @click="deleteEntity"
                            ><i class="far fa-trash"></i>
                            {{ $t("delete") }}</base-button
                        >
                    </div>
                    <div class="col text-right">
                        <base-button
                            type="secondary"
                            :outline="true"
                            @click="$emit('close')"
                            >{{ $t("cancel") }}</base-button
                        >
                        <base-button
                            type="primary"
                            :loading="saving"
                            native-type="submit"
                            >{{ $t("save") }}</base-button
                        >
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
